
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shrink-image-online",
      function () {
        return require("private-next-pages/shrink-image-online/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shrink-image-online"])
      });
    }
  